/**
 * Whether an event uses industry-scoped categories (from event type configuration).
 * Category-only event types must not show industry filters, columns, or labels in the UI.
 */
export function eventAllowsIndustryLinking(event) {
  if (!event) return false;

  const snap = event?.configSnapshot?.eventTypeConfiguration;
  const live = event?.eventType?.configuration;

  if (typeof snap?.allowIndustryCategoryLinking === 'boolean') {
    return snap.allowIndustryCategoryLinking;
  }
  if (typeof live?.allowIndustryCategoryLinking === 'boolean') {
    return live.allowIndustryCategoryLinking;
  }
  if (event.allowIndustryLinking === true) return true;

  return false;
}

/** Build a display label for industry + category, omitting industry when linking is off. */
export function formatIndustryCategoryLabel(
  { industryName, categoryName, marketLabel } = {},
  { allowIndustryLinking = false, separator = ' · ' } = {}
) {
  const parts = [];
  if (allowIndustryLinking && industryName) parts.push(String(industryName).trim());
  if (marketLabel) parts.push(String(marketLabel).trim());
  if (categoryName) parts.push(String(categoryName).trim());
  return parts.filter(Boolean).join(separator) || '—';
}

/** User-facing scope term for panel-head / verify copy. */
export function categoryScopeLabel({ allowIndustryLinking = false, plural = false } = {}) {
  if (allowIndustryLinking) {
    return plural ? 'industry-categories' : 'industry-category';
  }
  return plural ? 'categories' : 'category';
}

/** Whether industry should appear in UI for a row/item that carries the event flag. */
export function showIndustryForItem(item, { allowIndustryLinking } = {}) {
  const linking = typeof allowIndustryLinking === 'boolean'
    ? allowIndustryLinking
    : item?.allowIndustryCategoryLinking === true;
  if (!linking) return false;
  const industryName = String(item?.industry?.name || item?.industryName || '').trim();
  return Boolean(industryName);
}
